import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { Util } from '../common/common.util';

// DataCache.LookUp_PeriodType
export enum PeriodType {
    CUSTOM = -1,
    DAY,
    WEEK,
    MONTH,
    QUARTER,
    ROLLING_30,
    YEAR,
    WEEKS_6,
    ALL,
}

export interface ExtPeriod {
    periodValue: string;
    periodName: string;
    periodTypeID: number;
}

export interface DateRange {
    label: string;
    eventDate: Date;
    eventDateLocal: Date;
    type: PeriodType;
}

class PeriodModelTransformer implements ModelTransformer<DateRange, ExtPeriod> {
    transform(model: ExtPeriod): DateRange {
        return {
            label: model.periodName,
            eventDate: new Date(model.periodValue || ''),
            eventDateLocal: Util.dateToDate(model.periodValue),
            type: model.periodTypeID,
        };
    }
}

export class PeriodModelSetTransformer extends ModelSetTransformer<
    DateRange,
    ExtPeriod
> {
    protected newTransformer(): ModelTransformer<DateRange, ExtPeriod> {
        return new PeriodModelTransformer();
    }
}

export function validateDateRanges(model: DateRange[]): void {
    const valid = model != null && model.length !== 0;
    if (!valid) {
        throw new Error('DateRange not valid');
    }
}

export function datesForDateRange(dateRange: DateRange): Date[] {
    const start = new Date(dateRange.eventDateLocal);
    const end = new Date(dateRange.eventDateLocal);
    start.setDate(1);
    let delta = 0;
    switch (dateRange.type) {
        case PeriodType.MONTH:
            break;
        case PeriodType.QUARTER:
            delta = 2;
            break;
    }
    start.setMonth(start.getMonth() - delta);
    return [start, end];
}
